module.exports = __webpack_public_path__ + "static/logo-desktop-crypto-million-56c6791763f2a730b7ae0a5fb6ee516f.png";